import { Typography } from '@mui/material';
import { GridValidRowModel } from '@mui/x-data-grid-pro';

import { ClampedMultiline } from '~/components/ClampedMultiline/ClampedMultiline';
import { TooltipTypography } from '~/components/TooltipTypography/TooltipTypography';
export type ContentBlockCell = {
  title?: string;
  description?: string;
};

interface ContentBlockCellProps<R extends GridValidRowModel = any> {
  value: ContentBlockCell;
  row: R;
}

export const ContentBlockCell = <R extends GridValidRowModel = any>({ value }: ContentBlockCellProps<R>) => {
  const { title, description } = value;

  return (
    <div>
      {title && (
        <ClampedMultiline lines={1}>
          <TooltipTypography title={title}>
            <Typography variant="body2" color="textPrimary">
              {title}
            </Typography>
          </TooltipTypography>
        </ClampedMultiline>
      )}
      {description && (
        <ClampedMultiline lines={3}>
          <TooltipTypography title={description}>
            <Typography variant="body2" color="textSecondary" component="div">
              {description}
            </Typography>
          </TooltipTypography>
        </ClampedMultiline>
      )}
    </div>
  );
};
